export type PresentationMode = "classic" | "cards";

const VALID_MODES: PresentationMode[] = ["classic", "cards"];

function normalizeMode(value: unknown): PresentationMode | null {
  if (typeof value !== "string") return null;
  const normalized = value.trim().toLowerCase();
  if (VALID_MODES.includes(normalized as PresentationMode)) {
    return normalized as PresentationMode;
  }
  return null;
}

export function presentationFromSearch(search?: string | null): PresentationMode | null {
  if (!search) return null;
  const query = search.startsWith("?") ? search.slice(1) : search;
  const params = new URLSearchParams(query);
  return normalizeMode(params.get("presentation"));
}

export function presentationFromTheme(theme: { presentation?: unknown } | null | undefined): PresentationMode | null {
  return normalizeMode(theme?.presentation);
}

/**
 * URL override wins so authors can demo cards without a backend change.
 * Missing / unknown values fall back to classic so existing trainings stay unchanged.
 */
export function resolvePresentationMode(
  theme?: { presentation?: unknown } | null,
  search?: string | null
): PresentationMode {
  return presentationFromSearch(search) ?? presentationFromTheme(theme) ?? "classic";
}

export function formatSceneTopic(
  sceneType?: string | null,
  config?: { texts?: { title?: string }; title?: string } | null,
  moduleTitle?: string | null
): string {
  const configTitle = config?.texts?.title || config?.title;
  if (typeof configTitle === "string" && configTitle.trim()) return configTitle.trim();
  if (typeof moduleTitle === "string" && moduleTitle.trim()) return moduleTitle.trim();
  if (!sceneType) return "Lesson";
  return sceneType
    .split("_")
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}
